// 用户控制多页面之间的跳转

export enum PageAlias {
  home = 'home',
  login = 'login',
  records = 'records',
  application = 'application',
  setting = 'setting',
  wallet = 'wallet',
}

const pages: { [key in PageAlias]: string } = {
  [PageAlias.home]: 'home',
  [PageAlias.login]: 'login',
  [PageAlias.records]: 'records',
  [PageAlias.application]: 'application',
  [PageAlias.setting]: 'setting',
  [PageAlias.wallet]: 'wallet',
}

const basePath = process.env.REACT_APP_ROUTER_BASE_URL

function navigatePage(pageName: keyof typeof pages, queryString = '', _targetBlank = false) {
  const pagePath = pages[pageName]

  const pathPrefix = `${window.location.protocol}//${window.location.host}`

  const pageUrl = pathPrefix + basePath + pagePath + queryString

  if (_targetBlank) {
    window.open(pageUrl)
  } else {
    window.location.href = pageUrl
  }
}

export { navigatePage }
